// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"7f803abe","448":"0dcb2566","449":"b381c772","451":"1b318212","478":"01981eea","650":"5d311ecb","787":"b1de299e","895":"46f3cd0c"}[chunkId] + ".chunk.js";
};